import { SidebarProvider } from "@/components/ui/sidebar";
import Teacherheader from "./Teacherheader";
import Teachersidebar from "./Teachersidebar";
import SuspensionWarning from "./SuspensionWarning";
import useSuspensionCheck from "./useSuspensionCheck";
import SharedGradingDashboard from "../components/shared/SharedGradingDashboard";

const TeacherGrading = () => {
  const { isSuspended, isLoading: suspensionLoading, schoolName: suspendedSchoolName } = useSuspensionCheck();

  if (isSuspended) {
    return <SuspensionWarning schoolName={suspendedSchoolName} isLoading={suspensionLoading} />;
  }

  return (
    <SidebarProvider>
      <div className="flex min-h-[100dvh] w-full bg-[#FFFFFF] dark:bg-[#020817] font-plus-jakarta">
        <Teachersidebar />
        <div className="flex flex-col flex-1 min-h-0">
          <Teacherheader />
          <SharedGradingDashboard userRole="teacher" />
        </div>
      </div>
    </SidebarProvider>
  );
};

export default TeacherGrading;
